import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { derAutoCreateVirbom_terkk_ppv_children, derAutoCreateVirbom_terkk_ppv_children_special_for_parent, derAutoCreateVirbom_terkk_ppv_prepare_vir_input, derivatPoluproizvod_ppv_naziv } from "./ter-derivat-lib-terkk-ppv";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _enrich_virtel_from_unbundled_subDraftel_arr_with_fresh_subkey } from "./ter-virbom-datarender";
import tclocal from "./ter-consts-local-lib";


// TER DRAFTEL CODECS LIB

/*
// PPGRUPA VENTILATORI ali za sada idu odvojeno PPV i Nosač ventilatora


TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_ppv = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_ppv.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_ppv',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default
    /*
    vrstaprofila: null,
    msirinaspoljasnja: null,
    mvisinaspoljasnja: null,
    */

    ppv_isnapregradnom: "NE",
    ppv_vent_nanosacu: "", // NOVO 2023-08-22
    ppv_vent_amortizeri: "", // NOVO 2024-12-01
    ppv_vent_brojamortizera: "", // NOVO 2024-12-01
    ppv_brojventilatora: 1,
    ppv_kolikoredova: null,
    ppv_kolikokolona: "",
    // ppv_isojacanjaposirini: false,
    // ppv_isojacanjapovisini: false,
    ppv_isojacanjaposirini: true, // NJ 2024-08-29: Po defultu ukljuciti ojacanja.
    ppv_isojacanjapovisini: true, // NJ 2024-08-29: Po defultu ukljuciti ojacanja.
    ppv_tip: "1D",
    ppv_o1zazor: 12, // DL 2023-09-18: o1zazor se ne vuče iz baze ventilatora nego je zaseban podatak koji je uvek 12 ali neka ostane da može da se menja.
    ppv_o1: 0,
    ppv_o2: 0,
    ppv_sirinaojacanja: 53,
    ppv_dodatakzasavijanje: 40.8,
    ppv_bezotvora: false,

    // termaterijal: "LB00000J", // default materijal // LIM POCINKOVANI 1.50
    termaterijal: null, // NJ 2024-08-19: koriste se jedan od dva materijala prohrom (ako je komora) i u svim ostalim slucjaevima pocinkovani

    kolicina: 1,

    _ventilator_params: null, // frontend only

    ppv_servisni_prekidac_ident: null,
    ppv_servisni_prekidac_naziv: null,
    ppv_servisni_prekidac_kolicina: null,
    ppv_kontaktor_ident: null,
    ppv_kontaktor_naziv: null,
    ppv_kontaktor_kolicina: null,
    ppv_amortizer_ident: null,
    ppv_amortizer_naziv: null,
    ppv_amortizer_kolicina: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_ppv.default_pods_input_state = () => {
  /*
  return {
    vrstaprofila: null,
    msirinaspoljasnja: null,
    duzinamodula: null
  };
  */
  return default_pods_input_state_smart_get('terkk$ppv');
};


draftel_codecs_pack_terkk$_bundle_ppv.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_ppv_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_ppv.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 
  // "msirinaunutrasnja",
  // "mvisinaunutrasnja",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_ppv.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  // ...Object.keys(draftel_codecs_pack_terkk$eliminatorkapi.default_preset_state())
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_ppv.default_subform_item_preset_state()) // novo+++
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_ppv.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima

};


draftel_codecs_pack_terkk$_bundle_ppv.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$ppv');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  delete p._ventilator_params; // brisemo objekat koji je samo za frontend
  const ppvNaziv = derivatPoluproizvod_ppv_naziv(p.ppv_tip, p.ppv_b, p.ppv_h);
  p.naziv = ppvNaziv;
  //
  const _params = {
    "virtelclass": "terkk$ppv",
    "operacija": "OPSKL",
    "rc": "RCDE",
    tergrupa: "PPV",
    multitranslator_lang: "terkk$ppv/ppv",
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$ppv',
    "virtelclass": "terkk$ppv",
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$ppv") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


/////////


draftel_codecs_pack_terkk$_bundle_ppv.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(_sf_item_raw => {
      let subDraftel_ppv = {
        ...draftel_codecs_pack_terkk$_bundle_ppv.default_preset_state(),
        ..._sf_item_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(subDraftel_ppv);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_ppv.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$ppv');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  const paired_virtel = draftel_codecs_pack_terkk$_bundle_ppv.bundleDrafel_to_paired_virtel(bundleDraftel);

  const local_graphlevel = 1;
  _virbom_manipulator.add_as_first_virtel(virbom_ref, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  const _unbundled_subDraftel_arr = draftel_codecs_pack_terkk$_bundle_ppv.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);

  let pods_input_za_derivate = derAutoCreateVirbom_terkk_ppv_prepare_vir_input(paired_virtel); // ??? 
  let _der_virtel_children = derAutoCreateVirbom_terkk_ppv_children(pods_input_za_derivate, _unbundled_subDraftel_arr);
  console.log('_der_virtel_children ppv', _der_virtel_children);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children, local_graphlevel + 1, virbomCounter.generateFreshSubkey);


  // SPECIAL EXTRA STEP
  let _der_virtel_children_special_for_parent = derAutoCreateVirbom_terkk_ppv_children_special_for_parent(pods_input_za_derivate, _unbundled_subDraftel_arr);
  console.log('_der_virtel_children_special_for_parent ppv', _der_virtel_children_special_for_parent);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children_special_for_parent, local_graphlevel, virbomCounter.generateFreshSubkey);


  // ZAVRSENI KORACI ZA JEDAN pp3
  // ***ZAVRSENI KORACI ZA JEDAN pp3

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING


/*
draftel_codecs_pack_terkk$_bundle_ppv.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_ppv.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_ppv.keys_for_direct_cloning)
  };
  //
  return state;
};
*/